namespace Areas.Dialogs.GLMemo {
    "use strict";

    let projectId: number;
    let baseURL: string;

    export function getMemoProjectID() {
        return projectId;
    }

    export function fillRelatedAccountFields(e) {

        var form: DevExpress.ui.dxForm = $('#CreateGLMemoForm').dxForm('instance');

        var faucc: DevExpress.ui.dxTextBox = form.getEditor('FAUCostCenter') as DevExpress.ui.dxTextBox;
        var fauaccount: DevExpress.ui.dxTextBox = form.getEditor('FAUAccount') as DevExpress.ui.dxTextBox;
        var projectid: DevExpress.ui.dxTextBox = form.getEditor('ProjectId') as DevExpress.ui.dxTextBox;

        if (e.selectedItem != null) {
            faucc.option("value", e.selectedItem.accountNumber);
            fauaccount.option("value", e.selectedItem.projectNumber);
            projectid.option("value", e.selectedItem.projectId);
            projectId = e.selectedItem.projectId;
        } else {
            projectId = 0;
            projectid.option("value","0");
            faucc.option("value", null);
            fauaccount.option("value", null);
        }
    }

    export function fillRelatedGLTypeFields(e) {
        var form: DevExpress.ui.dxForm = $('#CreateGLMemoForm').dxForm('instance');

        var fauactivitytypelk: DevExpress.ui.dxTextBox = form.getEditor('GLActivityTypeLk') as DevExpress.ui.dxTextBox;

        if (e.selectedItem != null) {
            fauactivitytypelk.option("value", e.selectedItem.glActivityTypeLk);
        }

    }

    export function fillRelatedFAUSubField(e) {
        var form: DevExpress.ui.dxForm = $('#CreateGLMemoForm').dxForm('instance');

        var fausub: DevExpress.ui.dxTextBox = form.getEditor('FAUSub') as DevExpress.ui.dxTextBox;

        if (e.selectedItem != null) {
            fausub.option("value", e.selectedItem.ucopSubCodeLk);
        }

    }

    export function fillRelatedFAUFundField(e) {
        var form: DevExpress.ui.dxForm = $('#CreateGLMemoForm').dxForm('instance');

        var faufund: DevExpress.ui.dxTextBox = form.getEditor('FAUFund') as DevExpress.ui.dxTextBox;

        if (e.selectedItem != null) {
            faufund.option("value", e.selectedItem.fundingSourceCode);
        }

    }


    export class CreateGLMemoDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("CreateGLMemo", closeHandler, parameters, () => {
                const form = $("#CreateGLMemoForm").dxForm("instance");
                const formData: any = form.option("formData");

                projectId = parameters.projectId;
                if (parameters.calledFrom === "GL") {
                    baseURL = "/Finance/Balances/PostGLMemo";
                } else {
                    baseURL = "/Finance/Memos/PostGLMemo";
                }
                formData.ProjectName = parameters.projectName;
                formData.ProjectNumber = parameters.projectNumber;
                formData.ProjectId = parameters.projectId;
                formData.FAULocation = 4;
                formData.FAUObject = "";
                formData.FAUAccount = parameters.projectNumber;
                formData.IsPending = false;
                formData.IsInternalEntry = true;
                formData.IsCapitalization = false;
                formData.IsUploadPending = false;
                formData.IsActive = true;
                //default these, user can edit
                formData.GLAmount = 0;
                formData.GLTypeEntryLk = "ML";
                formData.GLActivityTypeLk = "Encumbrance"

                form.option("formData", formData);
            });
        }

        protected ok = (e: any) => {
            const form = $("#CreateGLMemoForm").dxForm("instance");
            const result: any = form.validate();

            if (result.isValid) {

                const newData: any = form.option("formData");
                if (newData.GLAmount === null) {
                    newData.GLAmount = 0;
                }

                sendRequest(`${baseURL}`, JSON.stringify(newData), "POST", () => {
                    this.close(DialogResult.Ok, null);
                });

            }
        }
    }


 

    
}
